var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cf-c-hr-text"},[_c('span',{staticClass:"cf-c-hr-text__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }